import React from 'react';
import { useTranslation } from 'react-i18next';
import { MainPageContent } from '../i18n/mainPageContent';
import { FlexContainer } from '../Layout';
import { TitleContentCard } from '../atoms/ContentCard';
import { BookWidget } from './BooksWidget/BooksWidget';
import './Home.css';
import BlogWidget from './BlogWidget/BlogWidget';
import CurrentActivityWidget from './CurrentActivityWidget/CurrentActivityWidget';
import styled from 'styled-components';
import ProjectsWidget from './ProjectsWidget/ProjectsWidget';

const WidgetsContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  @media (max-width: 900px) {
    flex-direction: column;
  }
`;

export const HomePage: React.FC<{}> = () => {
  const { t } = useTranslation(['main']);

  return (
    <>
      {/* Experimenting with a falling leaf background but it doesn't look quite good enough yet to leave toggled on */}
      {/* <LeafBackground /> */}
      <FlexContainer>
        <TitleContentCard style={{ fontFamily: 'Satisfy-Regular', width: '100%' }}>
          <div>
            <h1>{t(MainPageContent.landingPageTitle, { ns: ['main'] })}</h1>
          </div>
          <div>
            <h3>{t(MainPageContent.landingPageSubtitle, { ns: ['main'] })}</h3>
          </div>
        </TitleContentCard>
      </FlexContainer>
        <ProjectsWidget />
      <WidgetsContainer>
        <div style={{ flex: '50%' }}>
          <BlogWidget />
          <BookWidget />
        </div>
        <div style={{ flex: '50%' }}>
          <CurrentActivityWidget />
          {/* <ProjectsWidget /> */}
          {/* <SteamWidget /> */}
        </div>
      </WidgetsContainer>
    </>
  );
};
